import { UserManager } from "oidc-client-ts";

const userManager = new UserManager({
    authority: window._env_.AUTH_EXT_AUTHORITY ?? "",
    client_id: window._env_.AUTH_EXT_CLIENT_ID ?? "",
    scope: "openid email",
    redirect_uri: `${window.location.protocol}//${window.location.host}/auth/complete`,
});

export default userManager